<template>
    <div>
        <span v-for="lang in languages" :key="lang[0]">
            <router-link :to="'/languages/' + lang[0]" :lang="lang[0]">{{ lang[1] }}</router-link
            >,
        </span>
    </div>
</template>

<script>
export default {
  name: 'LanguageList',
  data () {
    return {
      languages: [
        ['es', 'Español'],
        ['de', 'Deutsch'],
        ['zh-Hant', '繁體中文'],
        ['ve', 'Tiếng Việt'],
        ['ar', 'العَرَبِيَّة'],
        ['ru', 'Русский'],
        ['ja', '日本語'],
        ['ne', 'नेपाली'],
        ['fr', 'Français'],
        ['ko', '한국어'],
        ['tl', 'tagalog'],
        ['sq', 'Shqiptar'],
        ['bs', 'Bosanski'],
        ['it', 'Italian'],
        ['pl', 'Polskie']
      ]
    }
  }
}
</script>
